import { Injectable } from '@angular/core';
import { FluxStandardAction } from 'flux-standard-action';
export type Action = FluxStandardAction<any, any>;

@Injectable()
export class UpdateActions {
  /**
  * @arg Declaration of the action to set update atributes
  **/
  static readonly SET_UPDATE = 'SET_UPDATE';
  /**
  * @arg Declaration reset update attribues
  **/
  static readonly RESET_UPDATE = 'RESET_UPDATE';
  /**
  * @method setUpdateInfo Store the update info
  * @param UpdateType stores customer Ex: cutomer
  * @param updateAttribute User email or phone number
  * @param updateValue User email or phone Ex: test@gmail.com or 2344567890 name
  * @param updatedDate stores Epoch timestamp Ex: 2345673456723
  * @return void
  **/
  static setUpdateInfo(isUpdated: string) {
    return {
      type: UpdateActions.SET_UPDATE,
      payload: { isUpdated }
    };
  }
  /**
  * @method resetUpdate reset the update info
  * @return void
  **/
  static resetUpdate() {
    return {
      type: UpdateActions.RESET_UPDATE,
      payload: {}
    };
  }

}
